// Header - Add class on hover
document.addEventListener("DOMContentLoaded", function () {
  const header = document.getElementById("site-header");

  if (header) {
    header.addEventListener("mouseenter", function () {
      header.classList.add("hovered");
    });

    header.addEventListener("mouseleave", function () {
      header.classList.remove("hovered");
    });
  }
});

// Product card - Change image on swatch click
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product-card").forEach(function (productCard) {
    const activeSwatch = productCard.querySelector(
      ".family-swatch.variante-activa"
    );
    if (activeSwatch) {
      const swatchId = activeSwatch.dataset.swatchId;
      productCard.querySelectorAll(".card__media").forEach(function (media) {
        media.classList.toggle("active", media.dataset.swatchId === swatchId);
      });
    }

    productCard.querySelectorAll(".family-swatch").forEach(function (swatch) {
      swatch.addEventListener("click", function (e) {
        e.preventDefault();

        const swatchId = swatch.dataset.swatchId;
        const newImage = swatch.dataset.productImage;
        const newUrl = swatch.dataset.productUrl;

        const imageEl = productCard.querySelector(".product-card-image");
        if (imageEl) imageEl.src = newImage;

        const linkEl = productCard.querySelector(".card-product-link");
        if (linkEl) {
          linkEl.href = newUrl;

          const currentAlt = linkEl.getAttribute("alt");
          if (currentAlt && currentAlt.includes("|")) {
            const [baseName] = currentAlt.split("|");
            linkEl.setAttribute("alt", `${baseName.trim()} | ${swatchId}`);
          } else {
            linkEl.setAttribute("alt", swatchId);
          }
        }

        const infolinkEl = productCard.querySelector(".product-info-card-link");
        if (infolinkEl) {
          infolinkEl.href = newUrl;

          const currentAlt = infolinkEl.getAttribute("alt");
          if (currentAlt && currentAlt.includes("|")) {
            const [baseName] = currentAlt.split("|");
            infolinkEl.setAttribute("alt", `${baseName.trim()} | ${swatchId}`);
          } else {
            infolinkEl.setAttribute("alt", swatchId);
          }
        }

        productCard.querySelectorAll(".family-swatch").forEach(function (el) {
          el.classList.remove("variante-activa");
        });
        swatch.classList.add("variante-activa");

        productCard.querySelectorAll(".card__media").forEach(function (media) {
          media.classList.toggle("active", media.dataset.swatchId === swatchId);
        });
      });
    });
  });
});


// SKIMS v5 - PDP gallery. Scope the controls to each slider instead of exposing
// plusSlides/currentSlide only after window.load (which caused errors on early clicks).
(() => {
  const sliderState = new WeakMap();

  function updateDots(slider, state) {
    const dots = slider.querySelectorAll('.dot');
    if (!dots.length || !state.count) return;
    const index = ((state.index - 1 + state.count) % state.count);
    dots.forEach((dot, i) => dot.classList.toggle('active', i === index));
  }

  function finishTransition(state) {
    if (!state.animating) return;
    state.animating = false;
    clearTimeout(state.fallbackTimer);
    if (state.index !== 0 && state.index !== state.count + 1) return;

    // Reposition instantly from a cloned slide to its corresponding real slide.
    state.index = state.index === 0 ? state.count : 1;
    state.wrapper.style.transition = 'none';
    state.wrapper.style.transform = `translateX(-${state.index * 100}%)`;
    state.wrapper.getBoundingClientRect();
    requestAnimationFrame(() => {
      // Avoid touching a slider removed by a Shopify section refresh.
      if (state.wrapper.isConnected) state.wrapper.style.transition = 'transform 0.3s ease';
    });
  }

  function initializeSlider(slider) {
    const wrapper = slider?.querySelector('.slides-wrapper');
    if (!wrapper) return null;
    if (sliderState.has(wrapper)) return sliderState.get(wrapper);

    const slides = Array.from(wrapper.children).filter((el) =>
      el.classList?.contains('mySlides') && !el.classList.contains('clone')
    );
    if (!slides.length) return null;

    const state = { wrapper, count: slides.length, index: 0, animating: false, fallbackTimer: null };
    sliderState.set(wrapper, state);

    if (slides.length === 1) {
      const nav = slider.querySelector('.product-slider-nav');
      if (nav) nav.hidden = true;
      updateDots(slider, state);
      return state;
    }

    // Only this slider's slides are cloned; other PDP/media sliders are untouched.
    const firstClone = slides[0].cloneNode(true);
    const lastClone = slides[slides.length - 1].cloneNode(true);
    firstClone.classList.add('clone');
    lastClone.classList.add('clone');
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.setAttribute('aria-hidden', 'true');
    wrapper.insertBefore(lastClone, slides[0]);
    wrapper.appendChild(firstClone);
    state.index = 1;
    wrapper.style.transition = 'none';
    wrapper.style.transform = 'translateX(-100%)';
    wrapper.getBoundingClientRect();
    requestAnimationFrame(() => {
      if (wrapper.isConnected) wrapper.style.transition = 'transform 0.3s ease';
    });

    wrapper.addEventListener('transitionend', (event) => {
      if (event.target !== wrapper || event.propertyName !== 'transform') return;
      finishTransition(state);
    });
    updateDots(slider, state);
    return state;
  }

  function initAllSliders(root = document) {
    if (root.matches?.('.product-media-slider')) initializeSlider(root);
    root.querySelectorAll?.('.product-media-slider').forEach(initializeSlider);
  }

  // Delegated listener supports Shopify section re-renders and fast user clicks.
  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-skims-slide-direction]');
    if (!control) return;
    const slider = control.closest('.product-media-slider');
    if (!slider) return;
    event.preventDefault();
    const state = initializeSlider(slider);
    if (!state || state.count <= 1 || state.animating) return;

    const direction = Number(control.dataset.skimsSlideDirection);
    if (direction !== -1 && direction !== 1) return;
    state.animating = true;
    state.index += direction;
    state.wrapper.style.transition = 'transform 0.3s ease';
    state.wrapper.style.transform = `translateX(-${state.index * 100}%)`;
    updateDots(slider, state);
    // Backstop for reduced-motion settings and browsers without transitionend.
    state.fallbackTimer = setTimeout(() => finishTransition(state), 380);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllSliders(), { once: true });
  } else {
    initAllSliders();
  }
  document.addEventListener('shopify:section:load', (event) => initAllSliders(event.target));
})();

// El menu abre y cierra con el elemento nativo <summary> y <header-drawer> de global.js.
// No se registra un evento en #drawer-close porque ese ID no existe en el tema.

// Re-enable hidden input once a variant is chosen inside pdp
document.addEventListener("DOMContentLoaded", () => {
  const selects = document.querySelectorAll('select[name="id"]');
  selects.forEach(select => {
    select.addEventListener("change", () => {
      const hiddenInput = select.form?.querySelector('input[name="id"]');
      if (!hiddenInput) return;
      hiddenInput.value = select.value;
      hiddenInput.disabled = !select.value;
    });
  });
});

// Recently viewed section
function getRecentlyViewedProducts() {
  var viewedProducts = [];
  var cookie = Cookies.get('recently_viewed_products');
  if (cookie) {
    viewedProducts = JSON.parse(cookie);
  }
  return viewedProducts;
}

function addRecentlyViewedProduct(productId) {
  var viewedProducts = getRecentlyViewedProducts();
  var index = viewedProducts.indexOf(productId);
  if (index > -1) {
    viewedProducts.splice(index, 1);
  }
  viewedProducts.unshift(productId);
  Cookies.set('recently_viewed_products', JSON.stringify(viewedProducts), { expires: 30, path: '/' });
}

// Cart drawer policies
var coll = document.getElementsByClassName("policy");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.display === "block") {
      content.style.display = "none";
    } else {
      content.style.display = "block";
    }
  });
}

// Mobile footer menu
var coll = document.getElementsByClassName("mb-menu-item");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.display === "flex") {
      content.style.display = "none";
    } else {
      content.style.display = "flex";
    }
  });
}